import { DropdownOptions } from '@components/common/formControl/dropdown';

export interface IdefaultAddSiteLeadFormInitialValues {
	siteName: string | null;
	contractorName: string | null;
	contractorNumber: string | null;
	contractType?: string;
	gradeUsed: string | null;
	brandUsed: string | null;
	glueUsedAtSite: string | null;
	competitionReason: string | null;
	secondaryCompetitionReason: DropdownOptions[];
	secondaryCompetitionReasonOther: string | null;
	siteLocation: string | null;
	substratesCombinations: DropdownOptions[];
	siteSpecialist: string | null;
	superVisorName: string | null;
	superVisorNumber: string | null;
	siteArea: string | null;
}

export const defaultAddSiteLeadFormInitialValues: IdefaultAddSiteLeadFormInitialValues = {
	siteName: '',
	contractorName: '',
	contractorNumber: '',
	contractType: '',
	gradeUsed: '',
	brandUsed: '',
	glueUsedAtSite: 'FV',
	competitionReason: '',
	secondaryCompetitionReason: [],
	secondaryCompetitionReasonOther: '',
	siteLocation: '',
	substratesCombinations: [],
	siteSpecialist: '',
	superVisorName: '',
	superVisorNumber: '',
	siteArea: '',
};

export type TGradeListDetails = {
	id: number;
	value: string;
};
export type TCompetitionListDetails = {
	id: number;
	value: string;
};

export const substratesOptions: DropdownOptions[] = [
	{ id: 1, value: 'PVC Sheet' },
	{ id: 2, value: 'WPC Board' },
	{ id: 3, value: 'Veneer' },
	{ id: 4, value: 'Acrylic Sheet' },
	{ id: 5, value: 'MDF Board' },
	{ id: 6, value: 'ACP Sheet' },
	{ id: 7, value: 'NA' },
];
